// ./src/api/customerApi.js

import api from './api';

// Existing API functions
export const getCustomers = () => {
  return api.get('/customers');
};

export const createCustomer = (customerData) => {
  return api.post('/customers', customerData);
};

export const updateCustomer = (id, customerData) => {
  return api.put(`/customers/${id}`, customerData);
};

export const assignCustomer = (id, salesUserId) => {
  return api.patch(`/customers/${id}/assign`, { salesUserId });
};

export const deleteCustomer = (id) => {
  return api.delete(`/customers/${id}`);
};

export const addDeal = (customerId, dealData) => {
  return api.post(`/customers/${customerId}/deals`, dealData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
};

export const updateDeal = (customerId, dealId, dealData) => {
  return api.put(`/customers/${customerId}/deals/${dealId}`, dealData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
};

export const deleteDeal = (customerId, dealId) => {
  return api.delete(`/customers/${customerId}/deals/${dealId}`);
};

export const getDealReceipt = (customerId, dealId) => {
  return api.get(`/customers/${customerId}/deals/${dealId}/receipt`, {
    responseType: 'blob', // Important for handling binary data
  });
};

// **Add getCustomerById Function**
export const getCustomerById = (id) => {
  return api.get(`/customers/${id}`);
};

export const getAllDeals = (params = {}) => {
  return api.get('/customers/deals', { params });
};

export const recordPayment = (customerId, dealId, paymentData) => {
  return api.post(`/customers/${customerId}/deals/${dealId}/payments`, paymentData);
};

export const setDealTaxInclusive = (customerId, dealId, taxInclusive) => {
  return api.patch(`/customers/${customerId}/deals/${dealId}/tax-inclusive`, { taxInclusive });
};

export default api;
